<template>
	<div @click="showSetting">
		<div id="top">
			<div class="w">
				<div class="left c8" style="color: #888;">
					<a href="/" class="c9" style="color: #888;">
						<em class="f mt1"><i class="iconfont icon-home2"></i></em>首页
					</a>
					<span class="vline">|</span>
					<span v-if="name == ''">
						<a rel="nofollow" href="javascript:;" class="c9" @click="login()" style="color: #888;">{{name}}请登录</a>
						<span class="vline" style="color: #888;">|</span>
						<a rel="nofollow" href="javascript:;" class="c9" @click="register()" style="color: #888;">注册<em class="c9 pl10"></em></a>
					</span>
					<span v-else>
						<a rel="nofollow" href="javascript:;" class="c9" style="color: #888;">您好：{{name}}</a>
						<span class="vline" style="color: #888;">|</span>
						<a rel="nofollow" href="javascript:;" class="c9" @click="quit" style="color: #888;">退出<em class="c9 pl10"></em></a>
					</span>
					
				</div>
				<ul id="tul" class="tul right">
					<!-- <li>
						<a rel="nofollow" href="javascript:;" @click="user">
							<em class="f f14 mr5 red"><i class="iconfont icon-dingdandingdanchaxun"></i></em>签到有礼
						</a>
					</li>
					<li><span class="vline">/</span></li> -->
					<li>
						<a rel="nofollow" href="javascript:;" @click="user_order">
							<!-- <em class="f f14 mr5 red"><i class="iconfont icon-dingdandingdanchaxun"></i></em> -->
							查询订单
						</a>
					</li>
					<li><span class="vline">|</span></li>
					<li class="nbt" @mouseleave="onMouseOutMember($event)" @mouseenter="onMouseOverMember($event)">
						<a rel="nofollow" href="javascript:;" @click="user">
							会员中心<em class="rdop"></em>
						</a>
						<div class="tuln" :style="activeMember">
							<a rel="nofollow" href="javascript:;" @click="user_order">我的订单</a>
							<a rel="nofollow" href="javascript:;" @click="user_fav">我的收藏</a>
							<a rel="nofollow" href="javascript:;" @click="user_coupon">我的优惠券</a>
							<a rel="nofollow" href="javascript:;" @click="user_address">收货地址</a>
						</div>
					</li>
					<!-- <li><span class="vline">/</span></li>
					<li>
						<a rel="nofollow" href="javascript:;" @click="user_grade">
							<em class="f f14 mr5 red"><i class="iconfont icon-dingdandingdanchaxun"></i></em>积分兑换
						</a>
					</li> -->
					<!-- <li><span class="vline">/</span></li> -->
					<!-- <li>
						<a href="javascript:;" @click="jiameng()" rel="nofollow" class="pr5">批发/代发</a>
					</li> -->
					<!-- <li><span class="vline">/</span></li>
					<li>
						<a rel="nofollow" @click="$router.push('/recharge')" href="javascript:;">
							<em class="f f14 mr5"></em>
							充值中心
						</a>
					</li> -->
					<li><span class="vline">|</span></li>
					<li class="nbt" @mouseleave="onMouseOut($event)" @mouseenter="onMouseOver($event)">
						<a rel="nofollow" href="javascript:;">
							<em class="f mt1"><i class="iconfont icon-shouji1"></i></em>手机版<em class="rdop"></em>
						</a>
						<div class="tuln" :style="activeCode">
							<img src="../assets/image/minapp_qw.jpg" width="124" height="141">
						</div>
					</li>
					<li><span class="vline">|</span></li>
					<li class="nbt" @mouseleave="onMouseOutHelp($event)" @mouseenter="onMouseOverHelp($event)">
						<a rel="nofollow" href="javascript:;" @click="help">
							帮助中心<em class="rdop"></em>
						</a>
						<div class="tuln" :style="activeHelp">
							<a rel="nofollow" href="/help/fangshi">如何订购</a>
							<a rel="nofollow" href="/help/huodaofukuan">货到付款</a>
							<a rel="nofollow" href="/help/zaixian">在线支付</a>
							<a rel="nofollow" href="/help/dianhuadinggou">电话订购</a>
							<a rel="nofollow" href="/help/kefu">客服中心</a>
						</div>
					</li>
					<!-- <li>
						<a href="javascript:;" @click="safes()" rel="nofollow" class="pr5">正品保障</a>
					</li> -->
				</ul>
				<div class="clear"></div>
			</div>
		</div>
		<div id="header">
			<div class="w">
				<div class="rel left">
					<a href="/" title="夜樱情趣,百变情趣,乐享生活" class="logo" rel="nofollow">
						<img src="../assets/image/logo.png">
					</a>
					<p class="chead"></p>
				</div>
				<div id="search" class="search left" @click="settingEvent($event)">
					<div class="ov">
						<input type="text" id="keywords" name="keywords" v-model="keywords" class="shl left" placeholder="想买什么，搜一搜，如飞机杯" onfocus ="if(placeholder=='想买什么，搜一搜，如飞机杯') {placeholder=''}" onblur ="if (placeholder=='') {placeholder='想买什么，搜一搜，如飞机杯'}" @click="tanchukuang()" @keyup.enter.prevent="searchEnterFun($event)">
						<button type="submit" class="left shr" @click="search(keywords)">搜索</button>
					</div>
					<div id="rec_results" class="g-rec-results" v-show="msgShow">
						<ul class="history-results">
							<li class="title gray"><span>搜索历史</span></li>
							<!-- <li> <i class="search-express-none"></i></li> -->
							<li class="history">
								<a tabindex="-1" target="_blank" href="">飞机杯</a>
							</li>
							<li class="history">
								<a tabindex="-1" target="_blank" href="">女优娃娃</a>
							</li>
						</ul>
						<ul class="rec-results">
							<li class="title gray">
								<span>精选推荐</span>
							</li>
							<li>
								<a tabindex="-1" target="_blank" href="">飞机杯</a>
							</li>
							<li>
								<a tabindex="-1" target="_blank" href="">女优娃娃</a>
							</li>
						</ul>
					</div>
					<div class="clear"></div>
					<p class="hotw" style="margin-top: 5px;">
						<span>
							<router-link :to="{path:'/shop/shopsearch?cate_id=13'}" target="_blank">
								仿真阳具
							</router-link>
						</span>
						<em class="vline">|</em>
						<span>
							<router-link :to="{path:'/shop/shopsearch?cate_id=10'}" target="_blank">
								阴臀倒模
							</router-link>
						</span>
						<em class="vline">|</em>
						<span>
							<router-link :to="{path:'/shop/shopsearch?cate_id=22'}" target="_blank">
								外用延时
							</router-link>
						</span>
						<em class="vline">|</em>
						<span>
							<router-link :to="{path:'/shop/shopsearch?cate_id=14'}" target="_blank">
								震动棒
							</router-link>
						</span>
						<em class="vline">|</em>
						<span>
							<router-link :to="{path:'/shop/shopsearch?cate_id=6'}" target="_blank">
								飞机杯
							</router-link>
						</span>
						<em class="vline">|</em>
						<span>
							<router-link :to="{path:'/shop/shopsearch?cate_id=33'}" target="_blank">
								阴蒂刺激
							</router-link>
						</span>
					</p>
					<div id="s_box"></div>
				</div>
				<div class="tr_c right" id="tcar" @mouseleave="onMouseOutCar($event)" @mouseenter="onMouseOverCar($event)">
					<a class="t_c" rel="nofollow"  @click="buycar">
						购物车
						<p id="qcar">{{number}}</p>
						<i class="ci_r">&gt;</i>
					</a>
					<div id="acar" style="z-index:99">
						<div class="ac_t alR" v-if="list == 0">您的购物车是空的,赶紧选购吧！</div>
						<div v-else>
							<ul class="acar">
								<li v-for="(item,index) in list.slice(0,3)" :key="index">
									<!-- <a href="javascript:;" target="_blank" @click="buycar">
										<img :src="item.pro.piclink" width="60" height="60" class="left">
										<p>{{item.pro.title}}</p>
										<p class="mt5">¥{{$fnc.toFixedZ(item.pro.price)}} x {{item.number}}</p>
									</a> -->
									<router-link :to="{path:'/detail', query:{id:item.pro.id}}"  target="_blank">
										<img :src="item.pro.piclink" width="60" height="60" class="left">
										<p>{{item.pro.title}}</p>
										<p class="mt5">¥{{$fnc.toFixedZ(item.pro.price)}} x {{item.number}}</p>
									</router-link>
								</li>
							</ul>
							<div class="ac_t">
								<a href="javascript:;" @click="buycar" class="srbtn mt5">
									<b class="f"></b> 去购物车结算
								</a>
							</div>
						</div>
					</div>
				</div>
				<div class="clear"></div>
			</div>
		</div>
		<!--head over-->
		<!-- 分类 -->
		<pc-menu></pc-menu>
		<!-- 轮播图 -->
		<pc-banner></pc-banner>
		<div id="hr_a" class="ov" style="z-index:1;top:180px;">
			<div style="padding:20px 7px 0px;">
				<div style="border-bottom:1px solid #aaa4b1;">
					<div>
						<div style="float:left;margin-left: 7px;margin-right: 12px;">
							<img src="../assets/picture/index/header.png" alt="">
						</div>
						<div v-if="name == ''">
							<h3 style="line-height:27px;font-size:16px;">Hi，您好！</h3>
							<span style="line-height:27px;">欢迎来到夜樱情趣</span>
						</div>
						<div v-else>
							<h3 style="line-height:27px;font-size:16px;">您好：{{name}}</h3>
							<span style="line-height:27px;">欢迎来到夜樱情趣</span>
						</div>
					</div>
					<div style="text-align:center;line-height:34px;border:1px solid #f00180;border-radius:20px; font-size:14px;color:#f00180;margin:16px 10px 0px;">
						<p>成为注册会员 享更高折扣 ></p>
					</div>
					<div style="margin:16px 10px 16px;overflow:hidden;" v-if="name == ''">
						<div class="res_pc" style="" @click="login()"><p style="width:40px;">登录</p></div>
						<div class="login_pc" style="line-height:30px;padding:0px 28px;width:30px;font-size:16px;color:#f00180;cursor:pointer;border:1px solid #f00180;margin-left:10px;float:left;" @click="login()"><p style="width:40px;">注册</p></div>
					</div>
					<div style="margin:16px 10px 16px;overflow:hidden;" v-else>
						<div @click="quit" style="width:100%;text-align:center;line-height: 30px;background: #f00180;font-size: 16px;color: #ffffff;cursor: pointer;float:left;"><p>退出</p></div>
					</div>
				</div>
				<div style="border-bottom:1px solid #aaa4b1;">
					<div style="padding:16px 10px;">
						<div style="margin-bottom:16px;">
							<div class="user_hover" style="width:50px;float:left;cursor:pointer;text-align:center;" @click="user_order()">
								<div><img src="../assets/picture/index/wuliu.png" alt="" width="32px" height="32px" style="margin-bottom: 6px;"></div>
								<span>查看物流</span>
							</div>
							<div class="user_hover" style="width:50px;float:left;margin:0 18px;cursor:pointer;text-align:center;" @click="user_order()">
								<div><img src="../assets/picture/index/orders.png" alt="" width="32px" height="32px" style="margin-bottom: 6px;"></div>
								<span>我的订单</span>
							</div>
							<div class="user_hover" style="cursor:pointer;text-align:center;" @click="user_address()">
								<div><img src="../assets/picture/index/address.png" alt="" width="32px" height="32px" style="margin-bottom: 6px;"></div>
								<span>收货地址</span>
							</div>
						</div>
						<div>
							<div class="user_hover" style="width:50px;float:left;cursor:pointer;text-align:center;" @click="user_fav()">
								<div><img src="../assets/picture/index/shoucang.png" alt="" width="32px" height="32px" style="margin-bottom: 6px;"></div>
								<span>我的收藏</span>
							</div>
							<div class="user_hover" style="width:50px;float:left;margin:0 18px;cursor:pointer;text-align:center;" @click="user_order()">
								<div><img src="../assets/picture/index/pinglun.png" alt="" width="32px" height="32px" style="margin-bottom: 6px;"></div>
								<span>我的评论</span>
							</div>
							<div class="user_hover" style="cursor:pointer;text-align:center;" @click="user_coupon()">
								<div><img src="../assets/picture/index/hongbao.png" alt="" width="32px" height="32px" style="margin-bottom: 6px;"></div>
								<span>我的红包</span>
							</div>
						</div>
					</div>
				</div>
				<div style="position:relative;">
					<div style="padding:16px 10px;z-index:11;">
						<div>
							<div style="font-size:20px;color:#f00180;font-weight:bold;">享受购物的乐趣</div>
							<div style="font-size:16px;margin-top:6px;">爱上我们从这一刻开始</div>
							<div style="margin-top:16px;"><img src="../assets/image/minapp_qw.jpg" alt="" width="100" height="100"></div>
							<span>夜樱情趣</span>
						</div>
					</div>
					<div style="position:absolute;right:0px;bottom:-80px;">
						<img src="../assets/picture/index/renwu.png" alt="" width="138">
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
/*引入公共方法*/
import Banner from "@/components/common/banner.vue"
import Menu from "@/components/common/menu.vue"
import { setCookie,getCookie,delCookie } from '../assets/js/cookie.js'
export default{
	components:{
		'pc-banner': Banner,
		'pc-menu': Menu,
	},
	data(){
		return{
			number:"",
			name: '',
			activeCode:"",
			activeMember:"",
			activeHelp:"",
			activeT:"",
			msgShow:false,
			keywords:"",
			list:"",

		}
	},
	// created(){
	// 	let that = this;
	// },
	mounted(){
		this.cartList();
		/*页面挂载获取保存的localStorage值，渲染到页面上*/
        if(window.localStorage.getItem("user")){
            this.name = JSON.parse(window.localStorage.getItem("user")).nickname
        }
	},
	methods:{
		//回车事件搜索
		 searchEnterFun(e){
			var keyCode = window.event ? e.keyCode : e.which;
			if(this.keywords != ""){
				if (keyCode == 13) {
					this.search(this.keywords)
				}
			}else{
                this.$confirm('请输入要搜索的关键字', '提示', {
                    confirmButtonText: '确认', // 确认按钮文字更换
                    cancelButtonText: '取消', // 取消按钮文字更换
                    showClose: true, // 是否显示右上角关闭按钮
                    type: 'warning' // 提示类型  success/info/warning/error
		        })
            }
		},

		login(){
			//指定跳转地址
			this.$router.push('/login')
		},
		register(){
			//指定跳转地址
			this.$router.push('/login')
		},
		safes(){
			//指定跳转地址
			this.$router.push('/safes')
		},
		jiameng(){
			//指定跳转地址
			this.$router.push('/jiameng')
		},
		search(keywords){
			var params = {};
            params.keywords = keywords || "";
			//指定跳转地址
			this.$router.push({path:'/search',query:{keywords:params.keywords,showVideo:1}});
		},
		buycar(){
			//指定跳转地址
			if(this.name != ""){
				//指定跳转地址
				this.$router.push('/car')
			}else{
				this.$router.push('/login')
			}
		},
		user(){
			if(this.name != ""){
				//指定跳转地址
				this.$router.push('/user_infor')
			}else{
				this.$router.push('/login')
			}
		},
		help(){
			//指定跳转地址
			this.$router.push('/help')
		},
		
		quit(){
			/*删除cookie*/
			localStorage.clear();
			sessionStorage.clear();
			this.$router.push({name:"Login"})
		},
		onMouseOver($event){
            $event.currentTarget.className="nbt on";
            this.activeCode = false;
        },
        onMouseOut($event){
            $event.currentTarget.className="nbt";
            this.activeCode = true;
        },
		onMouseOverCar($event){
            $event.currentTarget.className="tr_c right hv";
            // this.activeCode = false;
        },
        onMouseOutCar($event){
            $event.currentTarget.className="tr_c right";
            // this.activeCode = true;
        },
		onMouseOverMember($event){
            $event.currentTarget.className="nbt on";
            this.activeMember = false;
        },
        onMouseOutMember($event){
            $event.currentTarget.className="nbt";
            this.activeMember = true;
        },
		onMouseOverHelp($event){
            $event.currentTarget.className="nbt on";
            this.activeHelp = false;
        },
        onMouseOutHelp($event){
            $event.currentTarget.className="nbt";
            this.activeHelp = true;
        },
		tanchukuang(){
            // this.activeT="display:block;"
			this.msgShow = true;
        },
		showSetting(){
			this.$set(this, 'msgShow', false);
			//全局区域内点击时showSettingCon均为false
		},
		settingEvent(event){
			event.stopPropagation(); //此区域不受上面方法的影响
		},
		clickSetting(){
			this.$set(this, 'msgShow', !this.showSettingCon)
			//事件触发时showSettingCon显示隐藏状态互换
		},
		user_order(){
			//指定跳转地址
			if(this.name != ""){
				//指定跳转地址
				this.$router.push('/user_order')
			}else{
				this.$router.push('/login')
			}
		},
		user_address(){
			//指定跳转地址
			if(this.name != ""){
				//指定跳转地址
				this.$router.push('/user_address')
			}else{
				this.$router.push('/login')
			}
		},
		user_fav(){
			//指定跳转地址
			if(this.name != ""){
				//指定跳转地址
				this.$router.push('/user_fav')
			}else{
				this.$router.push('/login')
			}
		},
		user_coupon(){
			//指定跳转地址
			if(this.name != ""){
				//指定跳转地址
				this.$router.push('/user_coupon')
			}else{
				this.$router.push('/login')
			}
		},
		user_grade(){
			//指定跳转地址
			if(this.name != ""){
				//指定跳转地址
				this.$router.push('/user_grade')
			}else{
				this.$router.push('/login')
			}
		},
		//购物车
		cartList(){
            var cart_params = {};
            cart_params.uid = JSON.parse(window.localStorage.getItem("user")).id;
            this.$api.getShop.getCartList(cart_params).then(res => {
                if (res.code == 200) {
                    this.list = [];
					// this.number = res.result[0].data.length;
					if(res.result[0].all_price == ""){
                        this.number = 0;
                    }else{
                        this.number = res.result[0].data.length;
						var arr = res.result[0].data;
						arr.forEach((item,i) => {
							this.list.push(item);
						});
                    }
                    
                }
            });
        },
	}
}
</script>

<style scoped>
.activeCode,.activeT{display: none;}
.hide {
    display: none;
}
.g-rec-results {
    width: 492px;
}
.g-rec-results {
    position: absolute;
    left: 0;
    /* top: 41px; */
    width: 492px;
    height: 269px;
    border: 1px solid #e4e4e4;
    background: #FFF;
    z-index: 7000;
    overflow: hidden;
}
.g-rec-results ul.history-results {
    width: 200px;
}

.g-rec-results ul.history-results {
    float: left;
    width: 200px;
    height: 269px;
    border-right: 1px solid #efefef;
}
.g-rec-results ul {
    list-style-position: outside;
    list-style: none;
    padding: 0;
    margin: 0;
}
.g-rec-results ul.history-results li.title.gray {
    padding: 10px 0 0 15px;
    /* background: #EEE; */
}
.g-rec-results ul.history-results li.title {
    padding: 0 10px;
    color: #999;
    line-height: 28px;
	margin: 0 0 7px 0;
	float: none;
    position: relative;
}
.g-rec-results li {
    margin: 0;
    cursor: default;
    line-height: 24px;
    text-align: left;
    color: #666;
    overflow: hidden;
    /* +overflow: visible; */
}
.g-rec-results ul.history-results .search-express-none {
    display: block;
    width: 160px;
    height: 136px;
    margin: 40px auto;
    background: url(../assets/picture/search-express-none.png);
}
.g-rec-results ul.rec-results li.title{
    float: none;
    position: relative;
    padding: 10px 0 0 15px;
    margin: 0 0 7px 0;
    border: 0;
    color: #999;
    line-height: 28px;
}
.g-rec-results ul.rec-results li{
    float: left;
    position: relative;
    height: 26px;
    margin: 0 0 15px 15px;
    overflow: hidden;
    /* +overflow: visible; */
}
.g-rec-results li {
    margin: 0;
    cursor: default;
    line-height: 24px;
    text-align: left;
    color: #666;
    overflow: hidden;
    /* +overflow: visible; */
}
.g-rec-results ul.rec-results li a.high-light{
    border-color: #F60;
    _border-color: #e1e1e1;
    color: #F60;
    text-decoration: none;
}
.g-rec-results ul.rec-results li a{
    display: block;
    padding: 0 5px;
    border: 1px solid #e1e1e1;
    color: #666;
    white-space: nowrap;
}
.g-rec-results ul.rec-results li a.high-light:hover {
    color: #FFF;
}
.g-rec-results ul.rec-results li a:hover {
    border-color: #F60;
    color: #FFF;
    background: #F60;
    text-decoration: none;
}
.g-rec-results li.history{
	float: left;
    position: relative;
    height: 26px;
    margin: 0 0 15px 15px;
    overflow: hidden;
	/* margin: 0; */
    cursor: default;
    line-height: 24px;
    /* text-align: left; */
    color: #666;
    overflow: hidden;
}
.history a {
	display: block;
    padding: 0 5px;
    border: 1px solid #e1e1e1;
    color: #666;
    white-space: nowrap;
}
.login_pc:hover{
	background: #f00180;
}
.login_pc:hover p{
	color: #ffffff;
}
.res_pc{
	line-height: 30px;
    background: #f00180;
    padding: 0px 28px;
    width: 30px;
    font-size: 16px;
    color: #ffffff;
    cursor: pointer;
    float: left;
    border: 1px solid rgb(240, 1, 128);
}
.res_pc:hover{
	background: #ffffff;
	border: 1px solid #f00180;
}
.res_pc:hover p{
	color: #f00180;
}
.user_hover:hover span{
	color: #f00180;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue